import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, WarningModalBody } from '@trqk/components';
import { locale } from '@trqk/utils';

import { HASHES, PATHS } from '../../../constants';

/**
 * Modal content to be shown when the user's payment plan has a royalty capacity which is too low
 * for their current usage. This can happen if they downgrade via the Chargebee modal to a plan that
 * has a lower capacity than their usage. This modal effectively blocks the user from using any part
 * of the app aside from the Settings page, which can be used to select a different payment plan.
 * @param props - see {@link ModalContentProps}; here, we specify that props.input is an object
 * with a property called `planType` that is a {@link ChargebeePlanId}.
 */
export const ExcessUsage = (props: ModalContentProps<unknown>): JSX.Element => {
    const history = useHistory();

    return (
        <WarningModalBody width={600} height={360}>
            <h5 className="text-quinary-700 mt-2">
                {locale.enUS.USAGE_EXCEEDS_PLAN.TITLE}
            </h5>
            <p className="italic text-tertiary-400 mt-8">
                {locale.enUS.USAGE_EXCEEDS_PLAN.THANKS}
            </p>
            <p className="italic text-tertiary-400 mt-2">
                {locale.enUS.USAGE_EXCEEDS_PLAN.OUTGROWN_PLAN}
            </p>
            <div className="semibold text-black mt-10">
                <div className="mb-4">{locale.enUS.USAGE_EXCEEDS_PLAN.CTA}</div>

                <Button
                    color="primary-light-bg"
                    autoWidth={true}
                    handleClick={() => {
                        props.remove({ success: true, canceled: false });

                        history.push({
                            search: history.location.search,
                            pathname: PATHS.SETTINGS,
                            hash: HASHES.SETTINGS.PAYMENT_PLAN,
                        });
                    }}
                >
                    {locale.enUS.USAGE_EXCEEDS_PLAN.UPDATE_PLAN}
                </Button>
            </div>
        </WarningModalBody>
    );
};
